export default [
  { value: '', label: '' },
  { value: '1111', label: '1111  Oilseed and Grain Farming' },
  { value: '1112', label: '1112  Vegetable and Melon Farming' },
  { value: '1113', label: '1113  Fruit and Tree Nut Farming' },
  { value: '1114', label: '1114  Greenhouse, Nursery, and Floriculture Production' },
  { value: '1119', label: '1119  Other Crop Farming' },
  { value: '1121', label: '1121  Cattle Ranching and Farming' },
  { value: '1122', label: '1122  Hog and Pig Farming' },
  { value: '1123', label: '1123  Poultry and Egg Production' },
  { value: '1124', label: '1124  Sheep and Goat Farming' },
  { value: '1125', label: '1125  Aquaculture' },
  { value: '1129', label: '1129  Other Animal Production' },
  { value: '1131', label: '1131  Timber Tract Operations' },
  { value: '1132', label: '1132  Forest Nurseries and Gathering of Forest Products' },
  { value: '1133', label: '1133  Logging' },
  { value: '1141', label: '1141  Fishing' },
  { value: '1142', label: '1142  Hunting and Trapping' },
  { value: '1151', label: '1151  Support Activities for Crop Production' },
  { value: '1152', label: '1152  Support Activities for Animal Production' },
  { value: '1153', label: '1153  Support Activities for Forestry' },
  { value: '2111', label: '2111  Oil and Gas Extraction' },
  { value: '2121', label: '2121  Coal Mining' },
  { value: '2122', label: '2122  Metal Ore Mining' },
  { value: '2123', label: '2123  Nonmetallic Mineral Mining and Quarrying' },
  { value: '2131', label: '2131  Support Activities for Mining' },
  { value: '2211', label: '2211  Electric Power Generation, Transmission and Distribution' },
  { value: '2212', label: '2212  Natural Gas Distribution' },
  { value: '2213', label: '2213  Water, Sewage and Other Systems' },
  { value: '2361', label: '2361  Residential Building Construction' },
  { value: '2362', label: '2362  Nonresidential Building Construction' },
  { value: '2371', label: '2371  Utility System Construction' },
  { value: '2372', label: '2372  Land Subdivision' },
  { value: '2373', label: '2373  Highway, Street, and Bridge Construction' },
  { value: '2379', label: '2379  Other Heavy and Civil Engineering Construction' },
  { value: '2381', label: '2381  Foundation, Structure, and Building Exterior Contractors' },
  { value: '2382', label: '2382  Building Equipment Contractors' },
  { value: '2383', label: '2383  Building Finishing Contractors' },
  { value: '2389', label: '2389  Other Specialty Trade Contractors' },
  { value: '3111', label: '3111  Animal Food Manufacturing' },
  { value: '3112', label: '3112  Grain and Oilseed Milling' },
  { value: '3113', label: '3113  Sugar and Confectionery Product Manufacturing' },
  { value: '3114', label: '3114  Fruit and Vegetable Preserving and Specialty Food Manufacturing' },
  { value: '3115', label: '3115  Dairy Product Manufacturing' },
  { value: '3116', label: '3116  Animal Slaughtering and Processing' },
  { value: '3117', label: '3117  Seafood Product Preparation and Packaging' },
  { value: '3118', label: '3118  Bakeries and Tortilla Manufacturing' },
  { value: '3119', label: '3119  Other Food Manufacturing' },
  { value: '3121', label: '3121  Beverage Manufacturing' },
  { value: '3122', label: '3122  Tobacco Manufacturing' },
  { value: '3131', label: '3131  Fiber, Yarn, and Thread Mills' },
  { value: '3132', label: '3132  Fabric Mills' },
  { value: '3133', label: '3133  Textile and Fabric Finishing and Fabric Coating Mills' },
  { value: '3141', label: '3141  Textile Furnishings Mills' },
  { value: '3149', label: '3149  Other Textile Product Mills' },
  { value: '3151', label: '3151  Apparel Knitting Mills' },
  { value: '3152', label: '3152  Cut and Sew Apparel Manufacturing' },
  { value: '3159', label: '3159  Apparel Accessories and Other Apparel Manufacturing' },
  { value: '3161', label: '3161  Leather and Hide Tanning and Finishing' },
  { value: '3162', label: '3162  Footwear Manufacturing' },
  { value: '3169', label: '3169  Other Leather and Allied Product Manufacturing' },
  { value: '3211', label: '3211  Sawmills and Wood Preservation' },
  { value: '3212', label: '3212  Veneer, Plywood, and Engineered Wood Product Manufacturing' },
  { value: '3219', label: '3219  Other Wood Product Manufacturing' },
  { value: '3221', label: '3221  Pulp, Paper, and Paperboard Mills' },
  { value: '3222', label: '3222  Converted Paper Product Manufacturing' },
  { value: '3231', label: '3231  Printing and Related Support Activities' },
  { value: '3241', label: '3241  Petroleum and Coal Products Manufacturing' },
  { value: '3251', label: '3251  Basic Chemical Manufacturing' },
  { value: '3252', label: '3252  Resin, Synthetic Rubber, and Artificial and Synthetic Fibers and Filaments Manufacturing' },
  { value: '3253', label: '3253  Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing' },
  { value: '3254', label: '3254  Pharmaceutical and Medicine Manufacturing' },
  { value: '3255', label: '3255  Paint, Coating, and Adhesive Manufacturing' },
  { value: '3256', label: '3256  Soap, Cleaning Compound, and Toilet Preparation Manufacturing' },
  { value: '3259', label: '3259  Other Chemical Product and Preparation Manufacturing' },
  { value: '3261', label: '3261  Plastics Product Manufacturing' },
  { value: '3262', label: '3262  Rubber Product Manufacturing' },
  { value: '3271', label: '3271  Clay Product and Refractory Manufacturing' },
  { value: '3272', label: '3272  Glass and Glass Product Manufacturing' },
  { value: '3273', label: '3273  Cement and Concrete Product Manufacturing' },
  { value: '3274', label: '3274  Lime and Gypsum Product Manufacturing' },
  { value: '3279', label: '3279  Other Nonmetallic Mineral Product Manufacturing' },
  { value: '3311', label: '3311  Iron and Steel Mills and Ferroalloy Manufacturing' },
  { value: '3312', label: '3312  Steel Product Manufacturing from Purchased Steel' },
  { value: '3313', label: '3313  Alumina and Aluminum Production and Processing' },
  { value: '3314', label: '3314  Nonferrous Metal (except Aluminum) Production and Processing' },
  { value: '3315', label: '3315  Foundries' },
  { value: '3321', label: '3321  Forging and Stamping' },
  { value: '3322', label: '3322  Cutlery and Handtool Manufacturing' },
  { value: '3323', label: '3323  Architectural and Structural Metals Manufacturing' },
  { value: '3324', label: '3324  Boiler, Tank, and Shipping Container Manufacturing' },
  { value: '3325', label: '3325  Hardware Manufacturing' },
  { value: '3326', label: '3326  Spring and Wire Product Manufacturing' },
  { value: '3327', label: '3327  Machine Shops; Turned Product; and Screw, Nut, and Bolt Manufacturing' },
  { value: '3328', label: '3328  Coating, Engraving, Heat Treating, and Allied Activities' },
  { value: '3329', label: '3329  Other Fabricated Metal Product Manufacturing' },
  { value: '3331', label: '3331  Agriculture, Construction, and Mining Machinery Manufacturing' },
  { value: '3332', label: '3332  Industrial Machinery Manufacturing' },
  { value: '3333', label: '3333  Commercial and Service Industry Machinery Manufacturing' },
  { value: '3334', label: '3334  Ventilation, Heating, Air-Conditioning, and Commercial Refrigeration Equipment Manufacturing' },
  { value: '3335', label: '3335  Metalworking Machinery Manufacturing' },
  { value: '3336', label: '3336  Engine, Turbine, and Power Transmission Equipment Manufacturing' },
  { value: '3339', label: '3339  Other General Purpose Machinery Manufacturing' },
  { value: '3341', label: '3341  Computer and Peripheral Equipment Manufacturing' },
  { value: '3342', label: '3342  Communications Equipment Manufacturing' },
  { value: '3343', label: '3343  Audio and Video Equipment Manufacturing' },
  { value: '3344', label: '3344  Semiconductor and Other Electronic Component Manufacturing' },
  { value: '3345', label: '3345  Navigational, Measuring, Electromedical, and Control Instruments Manufacturing' },
  { value: '3346', label: '3346  Manufacturing and Reproducing Magnetic and Optical Media' },
  { value: '3351', label: '3351  Electric Lighting Equipment Manufacturing' },
  { value: '3352', label: '3352  Household Appliance Manufacturing' },
  { value: '3353', label: '3353  Electrical Equipment Manufacturing' },
  { value: '3359', label: '3359  Other Electrical Equipment and Component Manufacturing' },
  { value: '3361', label: '3361  Motor Vehicle Manufacturing' },
  { value: '3362', label: '3362  Motor Vehicle Body and Trailer Manufacturing' },
  { value: '3363', label: '3363  Motor Vehicle Parts Manufacturing' },
  { value: '3364', label: '3364  Aerospace Product and Parts Manufacturing' },
  { value: '3365', label: '3365  Railroad Rolling Stock Manufacturing' },
  { value: '3366', label: '3366  Ship and Boat Building' },
  { value: '3369', label: '3369  Other Transportation Equipment Manufacturing' },
  { value: '3371', label: '3371  Household and Institutional Furniture and Kitchen Cabinet Manufacturing' },
  { value: '3372', label: '3372  Office Furniture (including Fixtures) Manufacturing' },
  { value: '3379', label: '3379  Other Furniture Related Product Manufacturing' },
  { value: '3391', label: '3391  Medical Equipment and Supplies Manufacturing' },
  { value: '3399', label: '3399  Other Miscellaneous Manufacturing' },
  { value: '4231', label: '4231  Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers' },
  { value: '4232', label: '4232  Furniture and Home Furnishing Merchant Wholesalers' },
  { value: '4233', label: '4233  Lumber and Other Construction Materials Merchant Wholesalers' },
  { value: '4234', label: '4234  Professional and Commercial Equipment and Supplies Merchant Wholesalers' },
  { value: '4235', label: '4235  Metal and Mineral (except Petroleum) Merchant Wholesalers' },
  { value: '4236', label: '4236  Household Appliances and Electrical and Electronic Goods Merchant Wholesalers' },
  { value: '4237', label: '4237  Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers' },
  { value: '4238', label: '4238  Machinery, Equipment, and Supplies Merchant Wholesalers' },
  { value: '4239', label: '4239  Miscellaneous Durable Goods Merchant Wholesalers' },
  { value: '4241', label: '4241  Paper and Paper Product Merchant Wholesalers' },
  { value: '4242', label: '4242  Drugs and Druggists\' Sundries Merchant Wholesalers' },
  { value: '4243', label: '4243  Apparel, Piece Goods, and Notions Merchant Wholesalers' },
  { value: '4244', label: '4244  Grocery and Related Product Merchant Wholesalers' },
  { value: '4245', label: '4245  Farm Product Raw Material Merchant Wholesalers' },
  { value: '4246', label: '4246  Chemical and Allied Products Merchant Wholesalers' },
  { value: '4247', label: '4247  Petroleum and Petroleum Products Merchant Wholesalers' },
  { value: '4248', label: '4248  Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers' },
  { value: '4249', label: '4249  Miscellaneous Nondurable Goods Merchant Wholesalers' },
  { value: '4251', label: '4251  Wholesale Trade Agents and Brokers' },
  { value: '4411', label: '4411  Automobile Dealers' },
  { value: '4412', label: '4412  Other Motor Vehicle Dealers' },
  { value: '4413', label: '4413  Automotive Parts, Accessories, and Tire Retailers' },
  { value: '4421', label: '4421  Furniture Stores (retired)' },
  { value: '4422', label: '4422  Home Furnishings Stores (retired)' },
  { value: '4431', label: '4431  Electronics and Appliance Stores (retired)' },
  { value: '4441', label: '4441  Building Material and Supplies Dealers' },
  { value: '4442', label: '4442  Lawn and Garden Equipment and Supplies Retailers' },
  { value: '4451', label: '4451  Grocery and Convenience Retailers' },
  { value: '4452', label: '4452  Specialty Food Retailers' },
  { value: '4453', label: '4453  Beer, Wine, and Liquor Retailers' },
  { value: '4461', label: '4461  Health and Personal Care Stores (retired)' },
  { value: '4471', label: '4471  Gasoline Stations (retired)' },
  { value: '4481', label: '4481  Clothing Stores (retired)' },
  { value: '4482', label: '4482  Shoe Stores (retired)' },
  { value: '4483', label: '4483  Jewelry, Luggage, and Leather Goods Stores (retired)' },
  { value: '4491', label: '4491  Furniture and Home Furnishings Retailers' },
  { value: '4492', label: '4492  Electronics and Appliance Retailers' },
  { value: '4511', label: '4511  Sporting Goods, Hobby, and Musical Instrument Stores (retired)' },
  { value: '4512', label: '4512  Book Stores and News Dealers (retired)' },
  { value: '4521', label: '4521  Department Stores (retired)' },
  { value: '4529', label: '4529  Other General Merchandise Stores (retired)' },
  { value: '4531', label: '4531  Florists (retired)' },
  { value: '4532', label: '4532  Office Supplies, Stationery, and Gift Stores (retired)' },
  { value: '4533', label: '4533  Used Merchandise Stores (retired)' },
  { value: '4539', label: '4539  Other Miscellaneous Store Retailers (retired)' },
  { value: '4541', label: '4541  Electronic Shopping and Mail-Order Houses (retired)' },
  { value: '4542', label: '4542  Vending Machine Operators (retired)' },
  { value: '4543', label: '4543  Direct Selling Establishments (retired)' },
  { value: '4551', label: '4551  Department Stores' },
  { value: '4552', label: '4552  Warehouse Clubs, Supercenters, and Other General Merchandise Retailers' },
  { value: '4561', label: '4561  Health and Personal Care Retailers' },
  { value: '4571', label: '4571  Gasoline Stations' },
  { value: '4572', label: '4572  Fuel Dealers' },
  { value: '4581', label: '4581  Clothing and Clothing Accessories Retailers' },
  { value: '4582', label: '4582  Shoe Retailers' },
  { value: '4583', label: '4583  Jewelry, Luggage, and Leather Goods Retailers' },
  { value: '4591', label: '4591  Sporting Goods, Hobby, and Musical Instrument Retailers' },
  { value: '4592', label: '4592  Book Retailers and News Dealers' },
  { value: '4593', label: '4593  Florists' },
  { value: '4594', label: '4594  Office Supplies, Stationery, and Gift Retailers' },
  { value: '4595', label: '4595  Used Merchandise Retailers' },
  { value: '4599', label: '4599  Other Miscellaneous Retailers' },
  { value: '4811', label: '4811  Scheduled Air Transportation' },
  { value: '4812', label: '4812  Nonscheduled Air Transportation' },
  { value: '4821', label: '4821  Rail Transportation' },
  { value: '4831', label: '4831  Deep Sea, Coastal, and Great Lakes Water Transportation' },
  { value: '4832', label: '4832  Inland Water Transportation' },
  { value: '4841', label: '4841  General Freight Trucking' },
  { value: '4842', label: '4842  Specialized Freight Trucking' },
  { value: '4851', label: '4851  Urban Transit Systems' },
  { value: '4852', label: '4852  Interurban and Rural Bus Transportation' },
  { value: '4853', label: '4853  Taxi and Limousine Service' },
  { value: '4854', label: '4854  School and Employee Bus Transportation' },
  { value: '4855', label: '4855  Charter Bus Industry' },
  { value: '4859', label: '4859  Other Transit and Ground Passenger Transportation' },
  { value: '4861', label: '4861  Pipeline Transportation of Crude Oil' },
  { value: '4862', label: '4862  Pipeline Transportation of Natural Gas' },
  { value: '4869', label: '4869  Other Pipeline Transportation' },
  { value: '4871', label: '4871  Scenic and Sightseeing Transportation, Land' },
  { value: '4872', label: '4872  Scenic and Sightseeing Transportation, Water' },
  { value: '4879', label: '4879  Scenic and Sightseeing Transportation, Other' },
  { value: '4881', label: '4881  Support Activities for Air Transportation' },
  { value: '4882', label: '4882  Support Activities for Rail Transportation' },
  { value: '4883', label: '4883  Support Activities for Water Transportation' },
  { value: '4884', label: '4884  Support Activities for Road Transportation' },
  { value: '4885', label: '4885  Freight Transportation Arrangement' },
  { value: '4889', label: '4889  Other Support Activities for Transportation' },
  { value: '4911', label: '4911  Postal Service' },
  { value: '4921', label: '4921  Couriers and Express Delivery Services' },
  { value: '4922', label: '4922  Local Messengers and Local Delivery' },
  { value: '4931', label: '4931  Warehousing and Storage' },
  { value: '5111', label: '5111  Newspaper, Periodical, Book, and Directory Publishers (retired)' },
  { value: '5112', label: '5112  Software Publishers (retired)' },
  { value: '5121', label: '5121  Motion Picture and Video Industries' },
  { value: '5122', label: '5122  Sound Recording Industries' },
  { value: '5131', label: '5131  Newspaper, Periodical, Book, and Directory Publishers' },
  { value: '5132', label: '5132  Software Publishers' },
  { value: '5151', label: '5151  Radio and Television Broadcasting (retired)' },
  { value: '5152', label: '5152  Cable and Other Subscription Programming (retired)' },
  { value: '5161', label: '5161  Radio and Television Broadcasting Stations' },
  { value: '5162', label: '5162  Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers' },
  { value: '5171', label: '5171  Wired and Wireless Telecommunications (except Satellite)' },
  { value: '5172', label: '5172  Wireless Telecommunications Carriers (except Satellite) (retired)' },
  { value: '5174', label: '5174  Satellite Telecommunications' },
  { value: '5178', label: '5178  All Other Telecommunications' },
  { value: '5179', label: '5179  Other Telecommunications (retired)' },
  { value: '5182', label: '5182  Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services' },
  { value: '5191', label: '5191  Other Information Services (retired)' },
  { value: '5192', label: '5192  Web Search Portals, Libraries, Archives, and Other Information Services' },
  { value: '5211', label: '5211  Monetary Authorities-Central Bank' },
  { value: '5221', label: '5221  Depository Credit Intermediation' },
  { value: '5222', label: '5222  Nondepository Credit Intermediation' },
  { value: '5223', label: '5223  Activities Related to Credit Intermediation' },
  { value: '5231', label: '5231  Securities and Commodity Contracts Intermediation and Brokerage' },
  { value: '5232', label: '5232  Securities and Commodity Exchanges' },
  { value: '5239', label: '5239  Other Financial Investment Activities' },
  { value: '5241', label: '5241  Insurance Carriers' },
  { value: '5242', label: '5242  Agencies, Brokerages, and Other Insurance Related Activities' },
  { value: '5251', label: '5251  Insurance and Employee Benefit Funds' },
  { value: '5259', label: '5259  Other Investment Pools and Funds' },
  { value: '5311', label: '5311  Lessors of Real Estate' },
  { value: '5312', label: '5312  Offices of Real Estate Agents and Brokers' },
  { value: '5313', label: '5313  Activities Related to Real Estate' },
  { value: '5321', label: '5321  Automotive Equipment Rental and Leasing' },
  { value: '5322', label: '5322  Consumer Goods Rental' },
  { value: '5323', label: '5323  General Rental Centers' },
  { value: '5324', label: '5324  Commercial and Industrial Machinery and Equipment Rental and Leasing' },
  { value: '5331', label: '5331  Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)' },
  { value: '5411', label: '5411  Legal Services' },
  { value: '5412', label: '5412  Accounting, Tax Preparation, Bookkeeping, and Payroll Services' },
  { value: '5413', label: '5413  Architectural, Engineering, and Related Services' },
  { value: '5414', label: '5414  Specialized Design Services' },
  { value: '5415', label: '5415  Computer Systems Design and Related Services' },
  { value: '5416', label: '5416  Management, Scientific, and Technical Consulting Services' },
  { value: '5417', label: '5417  Scientific Research and Development Services' },
  { value: '5418', label: '5418  Advertising, Public Relations, and Related Services' },
  { value: '5419', label: '5419  Other Professional, Scientific, and Technical Services' },
  { value: '5511', label: '5511  Management of Companies and Enterprises' },
  { value: '5611', label: '5611  Office Administrative Services' },
  { value: '5612', label: '5612  Facilities Support Services' },
  { value: '5613', label: '5613  Employment Services' },
  { value: '5614', label: '5614  Business Support Services' },
  { value: '5615', label: '5615  Travel Arrangement and Reservation Services' },
  { value: '5616', label: '5616  Investigation and Security Services' },
  { value: '5617', label: '5617  Services to Buildings and Dwellings' },
  { value: '5619', label: '5619  Other Support Services' },
  { value: '5621', label: '5621  Waste Collection' },
  { value: '5622', label: '5622  Waste Treatment and Disposal' },
  { value: '5629', label: '5629  Remediation and Other Waste Management Services' },
  { value: '6111', label: '6111  Elementary and Secondary Schools' },
  { value: '6112', label: '6112  Junior Colleges' },
  { value: '6113', label: '6113  Colleges, Universities, and Professional Schools' },
  { value: '6114', label: '6114  Business Schools and Computer and Management Training' },
  { value: '6115', label: '6115  Technical and Trade Schools' },
  { value: '6116', label: '6116  Other Schools and Instruction' },
  { value: '6117', label: '6117  Educational Support Services' },
  { value: '6211', label: '6211  Offices of Physicians' },
  { value: '6212', label: '6212  Offices of Dentists' },
  { value: '6213', label: '6213  Offices of Other Health Practitioners' },
  { value: '6214', label: '6214  Outpatient Care Centers' },
  { value: '6215', label: '6215  Medical and Diagnostic Laboratories' },
  { value: '6216', label: '6216  Home Health Care Services' },
  { value: '6219', label: '6219  Other Ambulatory Health Care Services' },
  { value: '6221', label: '6221  General Medical and Surgical Hospitals' },
  { value: '6222', label: '6222  Psychiatric and Substance Abuse Hospitals' },
  { value: '6223', label: '6223  Specialty (except Psychiatric and Substance Abuse) Hospitals' },
  { value: '6231', label: '6231  Nursing Care Facilities (Skilled Nursing Facilities)' },
  { value: '6232', label: '6232  Residential Intellectual and Developmental Disability, Mental Health, and Substance Abuse Facilities' },
  { value: '6233', label: '6233  Continuing Care Retirement Communities and Assisted Living Facilities for the Elderly' },
  { value: '6239', label: '6239  Other Residential Care Facilities' },
  { value: '6241', label: '6241  Individual and Family Services' },
  { value: '6242', label: '6242  Community Food and Housing, and Emergency and Other Relief Services' },
  { value: '6243', label: '6243  Vocational Rehabilitation Services' },
  { value: '6244', label: '6244  Child Care Services' },
  { value: '7111', label: '7111  Performing Arts Companies' },
  { value: '7112', label: '7112  Spectator Sports' },
  { value: '7113', label: '7113  Promoters of Performing Arts, Sports, and Similar Events' },
  { value: '7114', label: '7114  Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures' },
  { value: '7115', label: '7115  Independent Artists, Writers, and Performers' },
  { value: '7121', label: '7121  Museums, Historical Sites, and Similar Institutions' },
  { value: '7131', label: '7131  Amusement Parks and Arcades' },
  { value: '7132', label: '7132  Gambling Industries' },
  { value: '7139', label: '7139  Other Amusement and Recreation Industries' },
  { value: '7211', label: '7211  Traveler Accommodation' },
  { value: '7212', label: '7212  RV (Recreational Vehicle) Parks and Recreational Camps' },
  { value: '7213', label: '7213  Rooming and Boarding Houses, Dormitories, and Workers\' Camps' },
  { value: '7223', label: '7223  Special Food Services' },
  { value: '7224', label: '7224  Drinking Places (Alcoholic Beverages)' },
  { value: '7225', label: '7225  Restaurants and Other Eating Places' },
  { value: '8111', label: '8111  Automotive Repair and Maintenance' },
  { value: '8112', label: '8112  Electronic and Precision Equipment Repair and Maintenance' },
  { value: '8113', label: '8113  Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance' },
  { value: '8114', label: '8114  Personal and Household Goods Repair and Maintenance' },
  { value: '8121', label: '8121  Personal Care Services' },
  { value: '8122', label: '8122  Death Care Services' },
  { value: '8123', label: '8123  Drycleaning and Laundry Services' },
  { value: '8129', label: '8129  Other Personal Services' },
  { value: '8131', label: '8131  Religious Organizations' },
  { value: '8132', label: '8132  Grantmaking and Giving Services' },
  { value: '8133', label: '8133  Social Advocacy Organizations' },
  { value: '8134', label: '8134  Civic and Social Organizations' },
  { value: '8139', label: '8139  Business, Professional, Labor, Political, and Similar Organizations' },
  { value: '8141', label: '8141  Private Households' },
  { value: '9211', label: '9211  Executive, Legislative, and Other General Government Support' },
  { value: '9221', label: '9221  Justice, Public Order, and Safety Activities' },
  { value: '9231', label: '9231  Administration of Human Resource Programs' },
  { value: '9241', label: '9241  Administration of Environmental Quality Programs' },
  { value: '9251', label: '9251  Administration of Housing Programs, Urban Planning, and Community Development' },
  { value: '9261', label: '9261  Administration of Economic Programs' },
  { value: '9271', label: '9271  Space Research and Technology' },
  { value: '9281', label: '9281  National Security and International Affairs' },
];



// WEBPACK FOOTER //
// ./src/data/industry.js